import { c as _c } from "react/compiler-runtime";
import type { ContentSegment } from "./media-utils";
import MediaThumbnail from "./MediaThumbnail";
interface ContentSegmentComponentProps {
  readonly segment: ContentSegment;
  readonly index: number;
}
const URL_REGEX = /(https?:\/\/[^\s<]+[^\s<.,;:!?)\]"'])/g;
function linkifyText(text: string, segmentIndex: number): React.ReactNode[] {
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match;
  let partIndex = 0;
  const regex = new RegExp(URL_REGEX.source, "g");
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(<span key={`${segmentIndex}-text-${partIndex++}`}>
          {text.slice(lastIndex, match.index)}
        </span>);
    }
    parts.push(<a key={`${segmentIndex}-link-${partIndex++}`} href={match[0]} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="tw-text-primary-300 hover:tw-text-primary-400 tw-transition tw-duration-300">
        {match[0]}
      </a>);
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) {
    parts.push(<span key={`${segmentIndex}-text-${partIndex}`}>
        {text.slice(lastIndex)}
      </span>);
  }
  return parts.length > 0 ? parts : [text];
}

/**
 * Component to render a single segment of content (text or media)
 */
export default function ContentSegmentComponent(t0) {
  const $ = _c(9);
  const {
    segment,
    index
  } = t0;
  if (segment.type === "text") {
    const t1 = `segment-${index}`;
    let t2;
    if ($[0] !== index || $[1] !== segment.content) {
      t2 = linkifyText(segment.content, index);
      $[0] = index;
      $[1] = segment.content;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t1 || $[4] !== t2) {
      t3 = <span key={t1}>{t2}</span>;
      $[3] = t1;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  if (segment.mediaInfo) {
    const t1 = `segment-${index}`;
    let t2;
    if ($[6] !== segment.mediaInfo || $[7] !== t1) {
      t2 = <MediaThumbnail key={t1} media={segment.mediaInfo} />;
      $[6] = segment.mediaInfo;
      $[7] = t1;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  return null;
}